module.exports = __webpack_public_path__ + "static/media/14.0d21bd78.png";